import {http} from '@/helpers/http-helper';

class Notification {
    constructor(uuid, createdAt, type, message, resourceId, isRead) {
        this.uuid = uuid;
        this.createdAt = createdAt;
        this.type = type;
        this.message = message;
        this.resourceId = resourceId;
        this.isRead = isRead;
    }
}

export const getNotifications = () => {
    return new Promise( (resolve, reject) => {
        const url = 'me/notifications';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let notifications = [];

                    response.data.forEach((notification) => {
                        notifications.push(
                            new Notification(
                                notification.uuid,
                                new Date(notification.createdAt),
                                notification.type,
                                notification.message,
                                notification.resourceId,
                                notification.isRead)
                        );
                    });

                    resolve(notifications);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getUserNotifications = (userId) => {
    return new Promise( (resolve, reject) => {
        const url = 'user/' + userId + '/notifications';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let notifications = [];

                    response.data.forEach((notification) => {
                        notifications.push(
                            new Notification(
                                notification.uuid,
                                new Date(notification.createdAt),
                                notification.type,
                                notification.message,
                                notification.resourceId,
                                notification.isRead)
                        );
                    });

                    resolve(notifications);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const markNotificationAsRead = (notificationId) => {
    return new Promise( (resolve, reject) => {
        const url = 'me/notifications/' + notificationId + '/read';
        http.post(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const markAllNotificationsAsRead = () => {
    return new Promise( (resolve, reject) => {
        const url = 'me/notifications/read';
        http.post(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createNotification = (message, headquartersId, departmentId, userIds) => {
    return new Promise( (resolve, reject) => {
        const url = 'me/notifications/';
        http.post(url, {message, headquartersId, departmentId, userIds})
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};